/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedeemActivationCodeResponse
 */
export interface RedeemActivationCodeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RedeemActivationCodeResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof RedeemActivationCodeResponse
     */
    message: string;
    /**
     * 
     * @type {boolean}
     * @memberof RedeemActivationCodeResponse
     */
    objectiveComplete?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedeemActivationCodeResponse
     */
    activationComplete?: boolean;
}

/**
 * Check if a given object implements the RedeemActivationCodeResponse interface.
 */
export function instanceOfRedeemActivationCodeResponse(value: object): value is RedeemActivationCodeResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function RedeemActivationCodeResponseFromJSON(json: any): RedeemActivationCodeResponse {
    return RedeemActivationCodeResponseFromJSONTyped(json, false);
}

export function RedeemActivationCodeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemActivationCodeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'objectiveComplete': json['objectiveComplete'] == null ? undefined : json['objectiveComplete'],
        'activationComplete': json['activationComplete'] == null ? undefined : json['activationComplete'],
    };
}

export function RedeemActivationCodeResponseToJSON(json: any): RedeemActivationCodeResponse {
    return RedeemActivationCodeResponseToJSONTyped(json, false);
}

export function RedeemActivationCodeResponseToJSONTyped(value?: RedeemActivationCodeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'objectiveComplete': value['objectiveComplete'],
        'activationComplete': value['activationComplete'],
    };
}

